import { render, staticRenderFns } from "./LinkedinIcon.vue?vue&type=template&id=7b5cd36c&"
import script from "./LinkedinIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkedinIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports